import { Link } from 'react-router-dom';

export default function CGVProPage() {
  return (
    <div className="legal-page min-h-screen bg-gray-50 py-8">
      <div className="max-w-3xl mx-auto px-4">
        {/* Logo */}
        <div className="text-center mb-8">
          <img
            src="/volovolo.png"
            alt="Volovolo"
            className="h-20 w-auto mx-auto"
          />
        </div>

        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-2xl font-bold mb-6">
            Conditions Generales de Vente (CGV) de volovolo.pro
          </h1>

          {/* 1. Definitions */}
          <h2 className="text-xl font-bold mt-6 mb-4">1. Definitions</h2>
          <ul className="list-disc ml-6 space-y-2 text-gray-700">
            <li>
              <strong>volovolo.pro :</strong> La plateforme web operee par Adam Issam,
              micro-entrepreneur (SIREN 988922241), agissant en tant qu'intermediaire
              technique entre vendeurs et acheteurs.
            </li>
            <li>
              <strong>Vendeur :</strong> Toute personne physique ou morale inscrite sur
              volovolo.pro proposant des produits a la vente.
            </li>
            <li>
              <strong>Acheteur / Client :</strong> Toute personne physique ou morale
              effectuant un achat sur volovolo.pro.
            </li>
            <li>
              <strong>Produit(s) :</strong> Biens ou services proposes par les vendeurs
              via volovolo.pro.
            </li>
            <li>
              <strong>Compte Basic :</strong> Formule gratuite permettant de vendre avec
              une commission de 10%.
            </li>
            <li>
              <strong>Compte Premium :</strong> Formule payante donnant droit a une
              commission reduite a 4% et a des services supplementaires (voir article 5).
            </li>
            <li>
              <strong>Stripe :</strong> Prestataire tiers de paiement utilise pour la
              gestion securisee des transactions.
            </li>
          </ul>

          {/* 2. Objet */}
          <h2 className="text-xl font-bold mt-8 mb-4">2. Objet</h2>
          <p className="text-gray-700 mb-4">
            Les presentes CGV ont pour objet de definir les conditions dans lesquelles
            les vendeurs proposent leurs produits via volovolo.pro et les conditions
            dans lesquelles les acheteurs effectuent leurs achats. volovolo.pro agit
            exclusivement en qualite d'intermediaire technique.
          </p>

          {/* 3. Inscription */}
          <h2 className="text-xl font-bold mt-8 mb-4">3. Inscription et acces a la plateforme</h2>
          <p className="text-gray-700 mb-2">
            3.1. Toute personne souhaitant vendre sur volovolo.pro doit creer un compte
            vendeur et accepter les presentes CGV.
          </p>
          <p className="text-gray-700 mb-2">
            3.2. volovolo.pro se reserve le droit de refuser ou suspendre l'acces en cas
            de non-respect des presentes conditions ou d'activites frauduleuses.
          </p>
          <p className="text-gray-700 mb-4">
            3.3. Le vendeur est responsable de la confidentialite de ses identifiants.
          </p>

          {/* 4. Obligations du vendeur */}
          <h2 className="text-xl font-bold mt-8 mb-4">4. Obligations du vendeur</h2>
          <p className="text-gray-700 mb-2">
            4.1. Le vendeur garantit que les produits proposes sont conformes aux lois
            en vigueur, exempts de defauts, et que les descriptions sont exactes.
          </p>
          <p className="text-gray-700 mb-2">
            4.2. Il s'engage a traiter les commandes dans les delais indiques, a assurer
            l'expedition et la livraison.
          </p>
          <p className="text-gray-700 mb-2">
            4.3. Le vendeur est responsable du service apres-vente, du traitement des
            retours et reclamations clients.
          </p>
          <p className="text-gray-700 mb-4">
            4.4. Le vendeur garantit detenir les droits necessaires sur les images,
            textes et contenus deposes.
          </p>

          {/* 5. Formules d'abonnement */}
          <h2 className="text-xl font-bold mt-8 mb-4">5. Formules d'abonnement et commissions</h2>
          <p className="text-gray-700 mb-2">
            5.1. Compte Basic (gratuit) : commission de 10% sur chaque vente realisee.
          </p>
          <p className="text-gray-700 mb-2">
            5.2. Compte Premium (abonnement payant) : commission reduite a 4%, avec en plus :
          </p>
          <ul className="list-disc ml-6 space-y-1 text-gray-700 mb-2">
            <li>Mise en avant prioritaire des produits dans les resultats de recherche</li>
            <li>Acces aux outils avances de gestion des commandes et statistiques</li>
            <li>Support prioritaire par chat</li>
          </ul>
          <p className="text-gray-700 mb-2">
            5.3. Certaines formules Premium peuvent inclure :
          </p>
          <ul className="list-disc ml-6 space-y-1 text-gray-700 mb-2">
            <li>Campagnes de promotion mensuelles</li>
            <li>Vente en live</li>
            <li>Gestion multi-boutiques avancee</li>
          </ul>
          <p className="text-gray-700 mb-4">
            5.4. Les frais appliques par Stripe pour le traitement des paiements sont a
            la charge du vendeur et independants des commissions volovolo.pro.
          </p>

          {/* 6. Commande et paiement */}
          <h2 className="text-xl font-bold mt-8 mb-4">6. Commande et paiement</h2>
          <p className="text-gray-700 mb-2">
            6.1. L'acheteur passe commande via volovolo.pro. Le vendeur doit confirmer
            la disponibilite et preparer l'expedition.
          </p>
          <p className="text-gray-700 mb-2">
            6.2. Le paiement est encaisse par volovolo.pro via Stripe.
          </p>
          <p className="text-gray-700 mb-2">
            6.3. volovolo.pro conserve le paiement jusqu'a confirmation de reception
            par l'acheteur ou expiration d'un delai legal, avant de reverser au vendeur.
          </p>
          <p className="text-gray-700 mb-4">
            6.4. En cas de demande de remboursement, celui-ci est realise apres
            restitution du produit au vendeur.
          </p>

          {/* 7. Droit de retractation */}
          <h2 className="text-xl font-bold mt-8 mb-4">7. Droit de retractation et retours</h2>
          <p className="text-gray-700 mb-2">
            7.1. Conformement a la loi, l'acheteur dispose d'un delai de 14 jours pour
            exercer son droit de retractation.
          </p>
          <p className="text-gray-700 mb-2">
            7.2. Le remboursement est effectue des que le vendeur recoit le produit
            retourne dans son etat initial.
          </p>
          <p className="text-gray-700 mb-4">
            7.3. Les frais de retour sont a la charge de l'acheteur, sauf disposition contraire.
          </p>

          {/* 8. Livraison */}
          <h2 className="text-xl font-bold mt-8 mb-4">8. Livraison</h2>
          <p className="text-gray-700 mb-2">
            8.1. Le vendeur est responsable de l'expedition et des delais de livraison.
          </p>
          <p className="text-gray-700 mb-2">
            8.2. Les frais de livraison sont soit a la charge de l'acheteur, soit inclus
            dans le prix.
          </p>
          <p className="text-gray-700 mb-4">
            8.3. volovolo.pro n'est pas responsable des retards ou defauts lies a la livraison.
          </p>

          {/* 9. Responsabilites */}
          <h2 className="text-xl font-bold mt-8 mb-4">9. Responsabilites et limitations</h2>
          <p className="text-gray-700 mb-2">
            9.1. volovolo.pro agit uniquement en tant qu'intermediaire technique et ne
            saurait etre tenu responsable des produits vendus, ni des litiges commerciaux
            entre vendeurs et acheteurs.
          </p>
          <p className="text-gray-700 mb-2">
            9.2. Le vendeur est seul responsable de la conformite et de la qualite des produits.
          </p>
          <p className="text-gray-700 mb-2">
            9.3. volovolo.pro ne garantit pas l'exactitude des informations fournies par
            les vendeurs.
          </p>
          <p className="text-gray-700 mb-4">
            9.4. La responsabilite de volovolo.pro est limitee aux frais de commission percus.
          </p>

          {/* 10. Propriete intellectuelle */}
          <h2 className="text-xl font-bold mt-8 mb-4">10. Propriete intellectuelle</h2>
          <p className="text-gray-700 mb-2">
            10.1. Les contenus deposes par les vendeurs restent leur propriete, sous
            reserve qu'ils disposent des droits.
          </p>
          <p className="text-gray-700 mb-2">
            10.2. Le vendeur garantit que ses publications ne portent pas atteinte aux
            droits de tiers.
          </p>
          <p className="text-gray-700 mb-4">
            10.3. volovolo.pro se reserve le droit de retirer tout contenu illicite ou litigieux.
          </p>

          {/* 11. Facturation */}
          <h2 className="text-xl font-bold mt-8 mb-4">11. Facturation</h2>
          <p className="text-gray-700 mb-2">
            11.1. volovolo.pro emet une facture au vendeur pour les commissions percues.
          </p>
          <p className="text-gray-700 mb-4">
            11.2. Le vendeur est responsable de ses obligations fiscales liees aux ventes realisees.
          </p>

          {/* 12. Litiges */}
          <h2 className="text-xl font-bold mt-8 mb-4">12. Litiges et mediation</h2>
          <p className="text-gray-700 mb-2">
            12.1. En cas de litige, volovolo.pro propose un service de mediation entre
            vendeur et acheteur.
          </p>
          <p className="text-gray-700 mb-2">
            12.2. Si aucun accord n'est trouve, les parties peuvent saisir les juridictions
            competentes.
          </p>
          <p className="text-gray-700 mb-4">
            12.3. La loi applicable est le droit francais.
          </p>

          {/* 13. Donnees personnelles */}
          <h2 className="text-xl font-bold mt-8 mb-4">13. Donnees personnelles</h2>
          <p className="text-gray-700 mb-2">
            13.1. Les donnees collectees sont traitees conformement a la politique de
            confidentialite de volovolo.pro.
          </p>
          <p className="text-gray-700 mb-4">
            13.2. Les vendeurs et acheteurs disposent de droits d'acces, rectification et opposition.
          </p>

          {/* Footer Links */}
          <div className="mt-8 pt-6 border-t border-gray-200">
            <div className="flex flex-wrap gap-4 text-sm text-gray-600">
              <Link to="/privacy-policy/pro" className="text-cyan-600 hover:underline">
                Politique de Confidentialite
              </Link>
              <Link to="/terms-of-use/pro" className="text-cyan-600 hover:underline">
                Conditions Generales d'Utilisation
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
